// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"6897567c","432":"51a91c38","479":"efc1922c","734":"6657abf9","799":"6e65fe19","944":"3187a749"}[chunkId] + ".chunk.js";
};